import React, { useEffect, useState, useRef } from 'react';
//import { Link, useNavigate } from "react-router-dom";
import { httpRequest, httpAuthHeaders } from '../../../../services/httpService';
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
import Loader from '../../../parts/Loader';
//import InputText from '../elements/InputText';
import RenderErrors from '../../../elements/RenderErrors';
import InputTextArea from '../../../elements/InputTextArea';
import ButtonGroupSelection from '../../../elements/ButtonGroupSelection';
import store from '../../../../services/store';
import helpers from '../../../../services/helpers';
import { getApiData } from '../../../../services/apiService';
import ContactListModal from '../../../modals/ContactListModal';
import Swal from 'sweetalert2';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
 
export default function SchedulesForm ({
        reference_id = '', 
        is_show = false, 
        setShow, 
        handleSave, 
        header_title="Schedule Information",
        src="customer",
        store_id="",
        index="",
        member_data={},
        direct_save,
        customer_id=''
    }){
    let default_data = {
        "id": "",
        "ship_id": "",
        "master_schedule_id": "",
        "departure_time": "",
        "estimated_arrival": "",
        "status_id": "",
        "voyage_no": ""
    }
    const toast = useRef(null);
    const [loading, setLoading] = useState(0);
    const [notice, setNotice] = useState('');
    const [form_data, setFormData] = useState(default_data);
    const [form_loaded, setFormLoaded] = useState(0);
    const [errors, setErrors] = useState([]);

    const [customer_modal, setContactModal] = useState(0);
    const [ship_list, setShipList] = useState([]);
    const [master_schedules_list, setMasterSchedulesList] = useState([]);
   
    useEffect(() => {
        setErrors([])

        if(is_show && reference_id){
            fetchData()
        }
        else if(is_show){
            fetchDropDowns()
            setFormData(default_data)
        }
    }, [is_show]);
   
    useEffect(() => {
        setErrors([])
        //console.log('form_data', form_data)
    }, [form_data]);
    

    function fetchData(){
        if(!reference_id){
            return
        }
        const url = helpers.createShipBookingHubUrl(`voyage/${reference_id}`)

        const convertTimeToDate = (timeString) => {
            if (!timeString) return null;

            // 1. Split "09:00" into [9, 0]
            const [hours, minutes] = timeString.split(':').map(Number);

            // 2. Create a new Date object (defaults to "now")
            const date = new Date();

            // 3. Set the hours and minutes from your string
            date.setHours(hours, minutes, 0, 0);

            return date;
        };

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            console.log('schedule', res)
            setFormData(res)
            //setFormData({...res, 'departure_time_formatted': convertTimeToDate(res.departure_time)})
            setLoading(0)
            setFormLoaded(1)
            fetchDropDowns()
        })
        .catch((err) => {
            setLoading(0)
            setFormLoaded(0)
            setFormData(default_data)
            toast.current.show({severity:'error', detail:err.message, life: 5000});
        }); 
    }

    function fetchDropDowns(){
        const url = helpers.createShipBookingHubUrl(`master-schedules`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setMasterSchedulesList(res)

            const ship_url = helpers.createShipBookingHubUrl(`ships`)
            setLoading(1)
            httpRequest(ship_url, "GET", {}, true)
            .then((res) => {
                setShipList(res)
                setLoading(0)
            })
            .catch((err) => {
                setLoading(0)
                setFormLoaded(0)
                toast.current.show({severity:'error', detail:err.message, life: 5000});
            }); 
        })
        .catch((err) => {
            setLoading(0)
            setFormLoaded(0)
            toast.current.show({severity:'error', detail:err.message, life: 5000});
        }); 
    }
    
    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            value = 0;
            
            if (e.target.checked) value = 1;
        }

        let new_state = { [name]: value }

        if(name === 'departure_time_formatted'){
            if (value) {
                const date = new Date(value);

                // 1. Get the hours and minutes from the user's selection
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                
                // 2. Combine into the strictly formatted string (HH:mm:ss)
                const formattedTime = `${hours}:${minutes}:00`;

                console.log('Formatted for DB:', formattedTime); // e.g., "14:30:00"

                // 3. Update state
                new_state['departure_time'] = formattedTime;
            } else {
                new_state['departure_time'] = '';
            }
        }

        setFormData({ ...form_data, ...new_state });
    }

    function validateForm(){
        let new_errors = {...errors}
        let variant_errors = 0;

        if(!form_data.name){
            new_errors['name'] = ['The name field is required.']
        }
        else{
            delete new_errors['name'];
        }

        if(!form_data.relationship){
            new_errors['relationship'] = ['The relationship field is required.']
        }
        else{
            delete new_errors['relationship'];
        }

        if(!form_data.gender){
            new_errors['gender'] = ['The gender field is required.']
        }
        else{
            delete new_errors['gender'];
        }

        if(form_data.age === null || form_data.age === undefined || form_data.age === ""){
            new_errors['age'] = ['The age field is required.']
        }
        else{
            delete new_errors['age'];
        }

        setErrors(new_errors);

        return new_errors;
    }



    function handleSubmit(e) {
        setLoading(1)

        let url = helpers.createShipBookingHubUrl('voyage')
        if(reference_id && form_loaded){
            url = helpers.createShipBookingHubUrl(`voyage/${reference_id}`)
        }

        httpRequest(url, 'POST', {
            postdata: form_data,
        }, true)
            .then((res) => {
                form_data.id = res.id
                setLoading(0)
                toast.current.show({severity:'success', detail:res.message, life: 20000});

                setShow(0);
                handleSave(form_data)
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                
                if(err.data){
                    setErrors( err.data );
                }else{
                    setErrors([])
                }

                toast.current.show({severity:'error', detail:err.message, life: 5000});
            }); 
    }

    function handleClose(e) {
        reset();
        setShow(0);
    }

    function reset(){
        setFormData([])
        setNotice('')
    }

    const footerContent = (
        <div>
            <Button label="Save" className='rounded' icon="fas fa-check" onClick={(e) => handleSubmit(1)} autoFocus />
        </div>
    );

    function handleCustomer(e){
        let data = {...form_data}

        data.customer_id = e.id ?? ''
        data.customer_name = e.contact_name ?? ''
        setFormData(data)
    }

    const formatMinutesToHours = (totalMinutes) => {
        if (!totalMinutes || totalMinutes < 0) return "0m";

        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        const hourPart = hours > 0 ? `${hours}h ` : "";
        const minutePart = minutes > 0 ? `${minutes}m` : "";

        return (hourPart + minutePart).trim() || "0m";
    };

    // 2. Helper to get the days as an array for the Table
    const dayKeys = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    const daysArray = dayKeys.map(key => ({
        id: key,
        name: key.toUpperCase(),
        active: form_data[key]
    }));

    // 3. Update logic for days
    const toggleDay = (dayKey) => {
        setFormData(prev => ({
            ...prev,
            [dayKey]: prev[dayKey] === 1 ? 0 : 1
        }));
    };

    const voyageTemplate = (option) => {
        if (!option) return <span>Select a voyage</span>;

        return (
            <div className="flex align-items-center">
                <span className="font-weight-bold mr-2">{option.origin} &rarr; {option.destination}</span>
                <span className="text-secondary mr-2">|</span>
                <span className="mr-2">{helpers.formatToTwelveHour(option.departure_time)}</span>
                <span className="text-secondary mr-2">|</span>
                <span className="font-bold mr-2">{option.voyage_prefix}</span>
            </div>
        );
    };

    return (
        <>
            <Toast ref={toast} position="top-center" />

            <ContactListModal is_show={customer_modal} setShow={setContactModal} handleSelect={handleCustomer} />

            <Dialog 
                visible={is_show} 
                position="top" 
                header={header_title} 
                //maximized={true}
                style={{ width: '40vw' }} 
                breakpoints={{ 
                    '960px': '75vw', // On Tablet (screen < 960px), use 75% width
                    '641px': '95vw'  // On Mobile (screen < 641px), use 95% width
                }}
                onHide={handleClose} 
                footer={footerContent}
                maximizable
            >
                <Loader isLoading={loading}/>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <label>Assigned Ship<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <Dropdown  
                                name='ship_id'
                                value={form_data.ship_id} 
                                onChange={(e) =>
                                    setFormData(prev => ({
                                        ...prev,
                                        'ship_id': e.value
                                    }))
                                } 
                                options={ship_list} 
                                optionLabel="name" 
                                optionValue="id" 
                                placeholder="Select Ship" 
                                className="w-100" 
                                checkmark={true} 
                                highlightOnSelect={false}
                                filterInputAutoFocus={true}
                                appendTo="self"
                                showClear
                                filter 
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="ship_id" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Voyage No<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputText
                                id="voyage_no" 
                                name="voyage_no" 
                                value={form_data.voyage_no}
                                tagClass="form-control mb-0"
                                placeholder="Voyage Prefix"
                                onChange={inputChange}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="voyage_no" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Master Schedule</label>
                        </div>
                        <div className="col-md-8 form-group">
                            <Dropdown  
                                name='master_schedule_id'
                                value={form_data.master_schedule_id} 
                                onChange={(e) =>
                                    setFormData(prev => ({
                                        ...prev,
                                        'master_schedule_id': e.value
                                    }))
                                } 
                                options={master_schedules_list} 
                                optionValue="id" 
                                className="w-100" 

                                optionLabel="ship_name" 
                                placeholder="Select a Voyage"
                                itemTemplate={voyageTemplate} // Formatting for the list
                                valueTemplate={voyageTemplate} // Formatting for the selected view

                                checkmark={true} 
                                highlightOnSelect={false}
                                filterInputAutoFocus={true}
                                appendTo="self"
                                showClear
                                filter 
                                disabled                               
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="master_schedule_id" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
            </Dialog>
        </>
    )
}